import { render } from "./UploadDoc.vue?vue&type=template&id=7a736ed4&scoped=true"
import script from "./UploadDoc.vue?vue&type=script&lang=js"
export * from "./UploadDoc.vue?vue&type=script&lang=js"

import "./UploadDoc.vue?vue&type=style&index=0&id=7a736ed4&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a736ed4"]])

export default __exports__